import Vue from 'vue';
import Vuex from 'vuex';
import CrazygameModule from '@/module/crazygame.module';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        crazyGame: CrazygameModule
    }
});
